export class OTA_OperatingCompany {
    public code: string;
    public companyShortName: string;
}
